module.exports = __webpack_public_path__ + "static/media/logo-white.18456404.png";